export default {
  resource:{
    zh: {
      title:"餐别",
      declareNo: "餐别编号",
      declareName: "餐别",
      btime: "订餐开始",
      etime:	"订餐结束",
      dfrom: "就餐开始",
      dto:	"就餐结束",
      discount:"折扣",
      addDay:"加天数",
      remark:	"备注",
      dc:"设备ID",
      status: "状态",
      status_false: "停用",
      status_true: "正常",
      dcType:"折扣类型",
      dcType1:"按比例",
      dcType2:"按金额",
      frequency:"允许消费次数",
      needOrder:"订餐否",
      needOrder1:"是",
      needOrder0:"否",
      nullNo:"餐别编号不能为空！",
      nullName:"餐别不能为空！",
      nullBT:"订餐时间开始不能为空！",
      nullET:"订餐时间结束不能为空！",
      nullDF:"就餐时间开始不能为空！",
      nullDT:"就餐时间结束不能为空！",
      nullDT:"就餐时间结束不能为空！",
      nullDC:"扣费比例不能为空！",
      discountM:"扣费比例不能小于0，且大于1！",
      nameExist:"餐别已经存在，请检查！",
      fixed:"价格",
      fixedTitle:"价格小于0则按消费机输入的价格算"
    }
    

  },
  delConf:["declareName"],
  params: {
    declareName:{
      key: "declareName",
      data: null,
      method: "Contains",
      type: "text"
    },
    declareNo:{
      key: "declareNo",
      data: null,
      method: "Contains",
      type: "text"
    }
  },
  listDefine: [
    "declareNo", "declareName",{key:"status", formatter:"fw"},{key:"btime", formatter:"ftime"},{key:"etime", formatter:"ftime"}
    ,{key:"dfrom", formatter:"ftime"}, {key:"dto", formatter:"ftime"}, "addDay", "fixed", {key:"dcType", formatter:"fdcType"},"discount",
    {key:"needOrder",formatter:"fnOrder"},{key:"frequency",width:150},{key:"remark", type:"textClumn"}
  ],
  formatter:{
    fw(v, cl, item){
      return "status_" + v
    },
    fdcType(v){
      return "dcType" + v
    },
    fnOrder(v){
      return v? "needOrder1":"needOrder0"
    }
  },
  bodyClass: "table-select", //table-multiselect table-select
  list: [],
  defaultSortName:"declareName",
  defaultSortOrder:"asc",
  sortName: "declareName",
  sortOrder: "asc",
  pageNo: 1,
  pageSize: 18,
  rowCount: 127,
  url: "dinnerSetting/",
  autoId: "autoid"

}
